import { OrderType } from './Order'

export type ApplyDiscountRequest = {
  code?: string
  clientEmail?: string
  orderType: OrderType
}

export enum DiscountTypes {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
  FREE_SHIPPING = 'FREE_SHIPPING',
  DIRECT = 'DIRECT',
}

export const DEFAULT_DISCOUNT_CODE = 'WAG40'

export const BLACK_FRIDAY_DISCOUNT_CODE = 'BLACKFRIDAY100'
